import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { DEFAULT_FONT_FAMILY, TIMESCALE } from '../../../constants/common';
import { getChartXYplotPointsForHour } from '../../../helpers/UsageDashboardHelper';

Highcharts.theme = {
  chart: {
    style: {
      fontFamily: DEFAULT_FONT_FAMILY
    }
  },
  title: {
    text: ''
  },
  subtitle: {
    text: ''
  },
  credits: {
    enabled: false
  }
};

Highcharts.setOptions(Highcharts.theme);

const BCLHighchart = React.forwardRef((props, ref) => {

  function setImageOnHourCurrentMinute(chart) {
    if(chart && chart.userOptions && chart.userOptions.xAxis && chart.series && chart.series.length) {
      if(chart.userOptions.xAxis[0].categories) {  //xAxis is present
        getChartXYplotPointsForHour(chart, props.mode, props.currentViewData);
      }
    }
  }

  return(
    <HighchartsReact
      highcharts={Highcharts}
      {...props}
      callback={(props.mode === TIMESCALE.HOUR || props.mode === TIMESCALE.DAY) ? setImageOnHourCurrentMinute : ''}
    />
  );
});
export default BCLHighchart;